var map = {
	"./business-recommend/icon/business-recommend.svg": 74394,
	"./buyers-library/icon/buyers-library.svg": 19378,
	"./customer-mining/icon/excavate.svg": 62844,
	"./customs-data/company-analyse/images/collapse.svg": 43745,
	"./customs-data/company-analyse/images/expand.svg": 95308,
	"./customs-data/icon/customs-data.svg": 97434,
	"./customs-data/icon/red.svg": 79580,
	"./customs-data/images/red.svg": 11297,
	"./dashboard/icon/home.svg": 88413,
	"./print-pdf-content/icon/risk-monitoring.svg": 70468,
	"./risk-monitoring/icon/risk-monitoring.svg": 30892
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72053;